export interface NavItem {
  path: string;
  label: string;
  icon: string;
  iconFilled?: string;
}

export const PRIMARY_NAV: NavItem[] = [
  { path: '/dashboard', label: 'Accueil', icon: 'home' },
  { path: '/benefits', label: 'Garanties', icon: 'verified_user' },
  { path: '/claims', label: 'Remboursements', icon: 'receipt_long' },
  { path: '/card', label: 'Ma Carte', icon: 'credit_card' },
  { path: '/profile', label: 'Profil', icon: 'person' },
];

export const SECONDARY_NAV: NavItem[] = [
  { path: '/providers', label: 'Prestataires', icon: 'medical_services' },
  { path: '/notifications', label: 'Notifications', icon: 'notifications' },
  { path: '/support', label: 'Support', icon: 'help' },
  { path: '/settings', label: 'Paramètres', icon: 'settings' },
];

export function isActivePath(pathname: string, navPath: string): boolean {
  if (navPath === '/dashboard') return pathname === '/dashboard';
  return pathname === navPath || pathname.startsWith(navPath + '/');
}
